import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addMoneyToWallet,
  fetchWalletDataFromAPI,
} from "../../utilities/services/wallet";

// Async thunk for adding money to the wallet
export const addMoney = createAsyncThunk(
  "wallet/addMoney",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addMoneyToWallet(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for fetching wallet data
export const fetchWalletData = createAsyncThunk(
  "wallet/fetchWalletData",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await fetchWalletDataFromAPI(userId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    balance: 0,
    status: "idle",
    loading: false,
    error: null,
    walletData: null, // Store wallet data (from fetchWalletData)
  },
  reducers: {
    clearWallet: (state) => {
      state.balance = 0;
      state.loading = false;
      state.error = null;
      state.walletData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Add money actions
      .addCase(addMoney.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addMoney.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.balance += parseFloat(action.payload.wallet_balance); // Update balance with the new wallet balance
      })
      .addCase(addMoney.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Fetch wallet data actions
      .addCase(fetchWalletData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWalletData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.length > 0) {
          state.walletData = action.payload[0]; // Store the first wallet data entry
          state.balance = parseFloat(action.payload[0].wallet_balance); // Initialize balance with the fetched balance
        } else {
          state.walletData = null;
        }
      })
      .addCase(fetchWalletData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearWallet } = walletSlice.actions;
export default walletSlice.reducer;
